export const reportIconStyle: React.CSSProperties = { fontSize: 20 };
export const reportIconButtonStyle: React.CSSProperties = {
  width: 30,
  paddingRight: 20,
};
